<div class="container-fluid p-0">
  <div class="hpanel">
    <div class="panel-body b-r-6">
      <div class="card">
        <div class="card-header p-10-30">
          <h6>Manage product access for all user in your organization</h6>
        </div>
        <div class="card-body">
          <app-plan-card [cards]="allocationCards" [TOTAL]="totalUsers"></app-plan-card>
          <div class="row">
            <div class="col-sm-12">
              <app-customer-search [placeholder]="'Search by user, email or gigsumo ID'"></app-customer-search>
            </div>

            <div class="custom-datatable col-lg-12 col-md-12 col-sm-12 ">
              <!-- Empty state -->
              <div *ngIf="listToShow?.length === 0" class="datatable-empty-state">
                <app-nodata-found
                  [title]="['No users found']"
                  [screen]="'EMPTY'"
                  [buttonShow]="false">
                </app-nodata-found>
              </div>

              <!-- Datatable with data -->
              <div *ngIf="listToShow?.length > 0">
                <ngx-datatable #sortTable (sort)="onSort($event)"class="bootstrap" [rows]="listToShow" [columnMode]="'force'" [headerHeight]="40"
                  [footerHeight]="50" rowHeight="auto" [selectAllRowsOnPage]="false" [externalPaging]="true"
                  [count]="totalUsers" [scrollbarH]="true" [offset]="userPayload.page" [limit]="10"
                  (page)="nextPage($event)">
                    <ngx-datatable-column cellClass="colValuesync" name="Gigsumo ID" prop="gigsumoNo">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <ng-container>
                          {{row.gigsumoNo || "N/A"}}
                        </ng-container>
                      </ng-template>
                    </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="User" [sortable]="true" prop="fullName">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div class="cell-flex" *ngIf="row.isSuperAdmin">
                        <div class="cell-item">
                          <ng-icon name="tablerCrown" class="cu-crown-icon"></ng-icon>
                        </div>
                        <div class="cell-item">
                          <label style="margin-bottom: 0px !important;">
                            {{row.fullName}}
                          </label>
                        </div>
                      </div>
                      <div *ngIf="!row.isSuperAdmin">
                        <label style="margin-bottom: 0px !important;">
                          {{row.fullName}}
                        </label>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Email ID" [sortable]="true" prop="username"
                    [width]="200"></ngx-datatable-column>
                    <ngx-datatable-column name="Role" prop="userType">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div class="custom-cell">{{ value ? (row?.userType | MTAPipe: 'convertMTA' | titlecase) : 'N/A' }}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Contract Role" prop="contractRoles" [width]="180">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="custom-cell">{{ getContractRoleLabels(row) }}</div>
                      </ng-template>
                    </ngx-datatable-column>

                  <ngx-datatable-column cellClass="colValuesync" name="Start Date" prop="createdOn" [width]="120">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <label>
                        {{row.createdOn | timezoneDate:'MM/dd/yyyy'}}
                      </label>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Last Active" prop="lastLoggedIn">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <label>
                        {{ row.lastLoggedIn ? (row.lastLoggedIn | timezoneDate:'MM/dd/yyyy') : 'N/A' }}
                      </label>
                    </ng-template>
                  </ngx-datatable-column>
                  

                  <ng-container *ngIf="MemberShipType != 'Free'">

                    <ngx-datatable-column name="Plan Access" prop="planAccessStatus">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div style="margin-left: 5px;" [ngStyle]="{'padding-inline-end': value === 'ACTIVE' ? '11px' : ''}">
                          <label [ngClass]="{ 'active-status-table': value === 'ACTIVE', 'inactive-status-table': value === 'INACTIVE',  'na-status-table': value === 'N/A'  }"  class="capitalize-first">
                            {{  value === 'ACTIVE'  ? 'Given'  : value === 'INACTIVE'  ? 'Not Given' : 'N/A' }}
                          </label> 
                        </div>
                      </ng-template>
                    </ngx-datatable-column> 

                  </ng-container>


                  <ngx-datatable-column cellClass="colValuesync" name="Status" prop="userStatus" [width]="120">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div class="status-button">
                        <!-- <div > -->
                          <!-- <ng-icon name="tablerX" *ngIf="row.userStatus === 'INACTIVE'" class="pointer"></ng-icon> -->
                          <!-- <ng-icon name="tablerBan" *ngIf="row.userStatus ==='BLOCKED'" class="pointer"></ng-icon> -->
                          <!-- <ng-icon name="tablerCheck" *ngIf="row.userStatus ==='ACTIVE'" class="pointer"></ng-icon> -->
                          <!-- <ng-icon name="tablerHourglass" *ngIf="row.userStatus ==='INITIATED'" class="pointer"></ng-icon> -->
                        <!-- </div> -->
                        <div style="margin-left: 5px;" [ngStyle]="{'padding-inline-end': row.userStatus === 'ACTIVE' ? '11px' : ''}">
                          <label  [ngClass]="{'active-status-table': row.userStatus === 'ACTIVE', 'inactive-status-table': row.userStatus === 'INACTIVE' || row.userStatus === 'BLOCKED' || row.userStatus === 'INITIATED'}"
                            class="capitalize-first">{{ row.userStatus}}</label>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column cellClass="colValuesync" name="Actions" prop="appAcess" [width]="80">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div class="wrapper-userlist">
                        <span class="action-items-userlist">
                          <ng-icon name="tablerPencil" class="svg-position" (click)="openEdit(row)"  title="Edit user" style="cursor: pointer;"></ng-icon>
                        </span>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
